import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'

import RootContainer from './RootContainer'

export default class AppContainer extends React.Component {
  static propTypes = {
		basename: PropTypes.string.isRequired,
		insurance: PropTypes.number.isRequired,
		project: PropTypes.string.isRequired,
    store: PropTypes.object.isRequired,
    website: PropTypes.string,
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    const { store, insurance, project, basename, website } = this.props
		return (
			<Provider store={store}>
				<div style={{ height: '100%' }}>
					<BrowserRouter basename={basename}>
						<Route path='/' render={props => <RootContainer {...props} insurance={insurance} project={project} website={website} />} />
					</BrowserRouter>
				</div>
			</Provider>
		)
  }
}
